/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import "../../../intl.js";
import { stripHTML as e } from "../../../core/string.js";
import { substitute as t } from "../../../intl/substitute.js";
import { formatNumber as n } from "../../../intl/number.js";
function r(e, t) {
  return t;
}
function i(e) {
  const t = this;
  e.appendChild(t);
}
function o(n, i, o) {
  if (!i) return;
  if ("number" == typeof i) return i;
  if ("string" == typeof i) return e(i);
  if ("value" in i || "unit" in i) return t(n.dotValue, i);
  if ("colorName" in i && "bandName" in i) return n[i.colorName] + ": " + (n[i.bandName] || i.bandName);
  if ("showCount" in i) return i.showCount ? n.clusterCountTitle : void 0;
  let u = null;
  return r(i, o) ? u = i.ratioPercentTotal ? "showRatioPercentTotal" : i.ratioPercent ? "showRatioPercent" : i.ratio ? "showRatio" : i.normField ? "showNormField" : i.field ? "showField" : null : l(i, o) && (u = i.normField ? "showNormField" : i.normByPct ? "showNormPct" : i.field ? "showField" : null), u ? t("showField" === u ? "{field}" : n[u], {
    field: i.field,
    normField: i.normField
  }) : void 0;
}
function l(e, t) {
  return !t;
}
function u(e, t) {
  return !!(t && "Stretched" === t && e.version >= 10.3 && "esri.layers.ImageryLayer" === e.declaredClass);
}
function a(e, t) {
  return e.label ? t[e.label] + ": " + ("string" == typeof e.value ? e.value : n(e.value ?? 0, {
    style: "decimal",
    notation: e.value?.toString().toLowerCase().includes("e") ? "scientific" : "standard"
  })) : "";
}
export { i as attachToNode, a as getStretchStopLabel, o as getTitle, u as isImageryStretchedLegend, l as isRendererTitle };